const STRINGS = {
  calendar: "Calendar",
  date: "Date",
  dateCannotBeAfter: after => `Date cannot be after ${after}`,
  dateCannotBeBefore: before => `Date cannot be before ${before}`,
  dateCannotBeBetween: (from, to) => `Date cannot be between ${from} and ${to}`,
  dateFormatMustBe: placeholder => `Enter date in ${placeholder} format.`,
  enteredDateIsDisabled: "Date not available. Enter or select a valid date to continue.",
  enteredDayIsDisabled: "Date not available. Enter or select a valid date to continue.",
  enterDateWithinSelectableRange: "Date not available. Enter or select a valid date to continue.",
  open: "Open",
  weekendsAreDisabled: "Date not available. Enter or select a valid date to continue.",
  invalidDate: "Date not available. Enter or select a valid date to continue.",
  invalidStartEndDate: "Start date must be earlier than end date.",
  todayButtonLabel: "Today"
};
export default STRINGS;